// extracted by mini-css-extract-plugin
export default {"body":"components_body__tzUxP","gridBg":"components_gridBg__r7EKD"};